export type UnauthorizedEventDetail = {
  source?: string;
  endpoint?: string;
};

export const emitUnauthorized = (detail?: UnauthorizedEventDetail) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('auth:unauthorized', { detail }));
};
